import React from 'react';
import {UploadAddImage} from './uploadAddImage'
import {CanvasAddImage} from './canvasAddImage'

import './style.css';
import Box from "@mui/material/Box";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {dataURItoBlob} from '@services/helper';
const {REACT_APP_ENV} = process.env

export const AddImage = ({data, handleClose, languageIndex=1}) => {
    const airMilesEnv = REACT_APP_ENV === 'AIRMILES'

    return (
        <Box>
            {airMilesEnv ? <UploadAddImage {...{data, handleClose, languageIndex}}/> : <CanvasAddImage {...{data, handleClose, languageIndex}} />}
        </Box>
    )
}
